export default function basicPostService(options) {
  return (params = {}) => $.ajax({
    url: options.pathHelper({...options.defaultParams, ...params}),
    type: 'POST',
    data: {
      user_id: options.defaultParams.user_id,
    }
  });
}

export const MarkProfileVisitorsAsReadService = basicPostService({
  defaultParams: {
    user_id: Aedu.User.current && Aedu.User.current.id,
    subdomain_param: "api"
  },
  pathHelper: $r.mark_as_read_api_v0_profile_visitors_path
});

